import { SettingsPageKind } from "client/Api/SettingsLayout/settingsLayout";
import { Navigation } from "client/Navigation";
import { isNotNil } from "client/Misc/utils";
import { FontIconName } from "client/Components";

export type AppStoreItem = {
	id: SettingsPageKind;
	kind: "app-store";
	name: string;
	featurePackage?: undefined;
};

export type LinkItem = {
	id: SettingsPageKind;
	kind: "link";
	name: string;
	navigation: Navigation | string;
};

export type GroupItem = {
	id: string;
	kind: "group";
	name: string;
	icon?: FontIconName;
	children: readonly ItemModel[];
};

export type ItemModel = LinkItem | GroupItem | AppStoreItem;

export type ItemId =
	| SettingsPageKind
	| string;

export function filterSettingsStructure(
	items: readonly ItemModel[],
	predicate: (item: ItemModel) => boolean
): readonly ItemModel[] {
	const result: ItemModel[] = [];

	for (const item of items) {
		const doesSatisfyCondition: boolean = predicate(item);

		if (!doesSatisfyCondition) {
			continue;
		}

		if (item.kind !== "group") {
			result.push({ ...item });
			continue;
		}

		const copy: GroupItem = {
			...item,
			children: filterSettingsStructure(item.children, predicate)
		};

		if (copy.children.length > 0) {
			result.push(copy);
		}
	}

	return result;
}

export function findPathToRoot(
	items: readonly ItemModel[],
	itemId: SettingsPageKind
): readonly ItemModel[] | undefined {
	for (const item of items) {
		if (item.id === itemId) {
			return [item];
		}

		if (item.kind === "group") {
			const childrenResult: readonly ItemModel[] | undefined = findPathToRoot(
				item.children,
				itemId
			);

			if (isNotNil(childrenResult)) {
				return [item, ...childrenResult];
			}
		}
	}

	return undefined;
}